export const GQL_OPERATION_NAME = 'searchThirdPartyFilterOptions';

export const THIRD_PARTY_FILTER_OPTIONS_QUERY: "\nquery searchThirdPartyFilterOptions($cloudId: ID!, $datasourceId: String!) {\n  search {\n    configuration(cloudId: $cloudId) {\n      thirdPartyFilterOptions(datasourceId: $datasourceId) {\n        filters {\n          name\n          values {\n            name\n            label\n          }\n        }\n      }\n    }\n  }\n}" = `
query ${GQL_OPERATION_NAME}($cloudId: ID!, $datasourceId: String!) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartyFilterOptions(datasourceId: $datasourceId) {
        filters {
          name
          values {
            name
            label
          }
        }
      }
    }
  }
}`;

export const getThirdPartyFilterOptionsQuery = (): string => THIRD_PARTY_FILTER_OPTIONS_QUERY;
